/*
* Actions supported by user activation modal wrapper
* The action is used to choose the description copy
*/
export const SUPPORTED_ACTIONS = {
    GET_A_QUOTE: 'get_a_quote',
    CONTACT_SELLER: 'contact_seller'
};
